import { useQuery } from 'react-apollo'
import { ListCompendiumPanels } from '../../../graphql/packages/queries'
import { CompendiumPanelPage, CompendiumFilter, CompendiumSort, CompendiumPanelTypeEnum } from '@labsavvyapp/components'

/**
 *  Query to get a list of Partners based on user

 * @returns Provider
 */

interface ListCompendiumPanelsVariables {
  limit?: number
  page?: number
  type?: 'group' | 'individual' | 'any'
  search?: string
  providerId: string | null
  sort?: CompendiumSort
}

export const useQueryListCompendiumPanelsApi = (variables: ListCompendiumPanelsVariables) => {
  const { limit, page, type, search, providerId, sort } = variables

  const {
    data: listCompendiaPanelsData,
    error: listCompendiaPanelsError,
    loading: listCompendiaPanelsLoading,
    refetch: refetchListCompendiaPanelsData,
    fetchMore: fetchMoreListCompendiaPanelsData,
  } = useQuery(ListCompendiumPanels, {
    variables: {
      limit: limit ?? 2000, // this wont be a heavy transaction because there
      page: page,
      search: search ?? '',
      type: 'any',
      providerId: providerId,
      sort: sort,
      removeZeroPriceTests: true,
    },
    skip: !providerId,
  })

  return {
    data: listCompendiaPanelsData?.listCompendiumPanels as CompendiumPanelPage,
    error: listCompendiaPanelsError,
    loading: listCompendiaPanelsLoading,
    refetch: refetchListCompendiaPanelsData,
    fetchMore: fetchMoreListCompendiaPanelsData,
  }
}
